<template>
  <div class="flex-cc"  style="width: 100%" >
    <div>
      <t-button @click="visible = true" >选择商品</t-button>
      <t-button v-if="tableData.length>0" @click="doDel()"  >删除商品</t-button>
    </div>
    <t-table ref="data" border style="width: 100%" :data="tableData"
             @selection-change="selectionChange"
             :header="tableHeader"></t-table>
  </div>
  <el-dialog title="选择商品" v-model="visible" width="1240px">
    <page-request ref="table" url="/api/mgr/shop/business/goods/list" :table-header="tableHeader" :expend="expend" :prop="{goodsType:type}" :hide-op="true"></page-request>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="visible=false">取消</el-button>
            <el-button type="primary" @click="doSelect()">选择</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>

import TButton from "@/components/el/t-button.vue";
import TTable from "@/components/el/t-table.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";

export default {
  props:{
    type:{
      type:Number,
      default:1
    }
  },
  name: "goods-select",
  components: {BButton, PageRequest, TTable, TButton},
  data() {
    return {
      visible:false,
      tableData:[],
      tableHeader:[
        {type: "selection", label: ""},
        {type: "goods", label: "商品",minWidth:300},
        {label: "价格",renderDraw:row=>{
            let content = "";
            if(row.storeGoodsType===1 ){
              content = "租赁价格:￥"+row.marketPrice+"元";
            }else if(row.storeGoodsType===2){
              content = "出售价格:￥"+row.salesPrice+"元<br/>"+"租赁价格:￥"+row.marketPrice+"元"
            }else{
              content = "出售价格:￥"+row.salesPrice+"元";
            }
            return content + (row.isAttribute?"起":"");
          },width:220},
        {label: "状态",renderDraw:row=>{return row.enables?"在售":"下架";},width: 100},
        //{prop: "updateTime", label: "更新时间",width:160},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend: [
        {label: "商品名称", prop: "name"},
        {label: "商品ID", prop: "codes"},
        //{label: "更新时间", start: "updateTimeStart", end: "updateTimeEnd", type: "daterange"},
        {label: "创建时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ],
    }
  },
  computed:{
    selectIds(){
      return this.tableData.map(item=>item.id);
    }
  },
  mixins: [tableBase],
  methods: {
    selectionChange(list){
      this.selectItems = list;
    },
    doSelect(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        this.tableData.pushAll(list.filter(item=>this.selectIds.indexOf(item.id)===-1));
        this.visible =false;
        this.$emit('change',this.tableData);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    doDel(){
      if(this.selectItems&&this.selectItems.length>0){
        this.selectItems.forEach(item=>{
          this.tableData.splice(this.tableData.indexOf(item),1);
        })
        this.$emit('change',this.tableData);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    setTableData(val){
      this.tableData =[];
      val.forEach(row=>{
        row.id = row.goodsId;
        this.tableData.push(row);
      });
      this.$emit('change',this.tableData);
    },
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
